module.exports = __webpack_public_path__ + "static/img/doi.cbb942b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/doi.png
// module id = k9Tv
// module chunks = 16